import { useEffect, useState } from 'react';
import useAttachmentManager from '#/common/components/AttachmentUpload/hooks/useAttachmentManager';
import imageNA from '#/static/image-na.webp';

export function useModelProfileImage(modelId?: string | null): string {
  const [src, setSrc] = useState<string>(imageNA);

  const { currentAttachments } = useAttachmentManager({
    relatedTable: 'models',
    relatedItem: modelId || '',
    attachmentType: 'profile',
  });

  useEffect(() => {
    if (!modelId || !currentAttachments) return;

    const profileImage = currentAttachments.find(
      (a: any) => a?.type === 'profile' && String(a?.mimeType || '').includes('image'),
    );

    if (profileImage) {
      setSrc(profileImage.downloadUrl || imageNA);
    } else {
      setSrc(imageNA);
    }
  }, [modelId, currentAttachments]);

  return src;
}
